/* eslint-disable @typescript-eslint/no-unsafe-argument */
import ApiClient from '@package/services/src/ApiClient'
import Result, { EmptyResult } from '@package/services/src/Result'

import { AffirmCheckoutObject } from '../types'

import { AffirmPaymentService } from './services'
import { AffirmCheckoutRequest } from './types'

export default class AffirmPaymentApiService implements AffirmPaymentService {
  public constructor(private apiClient: ApiClient) { }

  public async createCheckoutObject(): Promise<Result<AffirmCheckoutObject>> {
    const res = await this.apiClient.put(
      '/shoppingCart/paymentMethod/affirm/checkout'
    )

    const json = await res.json()
    const affirmCheckoutObject: AffirmCheckoutObject = JSON.parse(
      json.affirmCheckout
    )


    return new Result(affirmCheckoutObject)
  }

  public async checkout(request: AffirmCheckoutRequest): Promise<EmptyResult> {
    await this.apiClient.put('/shoppingCart/paymentMethod/affirm/authorize', {
      body: request,
    })


    return new EmptyResult()
  }
}
